import { createSlice } from "@reduxjs/toolkit";
import { InquiryDetailJson } from "../../../domain/inquiry/InquiryDetail";
import { InquiryListItemJson } from "../../../domain/inquiry/InquiryListItem";
import { ActionType, getInquiryListAction, getInquiryDetailAction, updateInquiryAction, registerInquiryAction } from "./actions";

export type InquiryState = Readonly<{
    inquiries: InquiryListItemJson[] | null,
    processing: number,
    inquiryDetail: InquiryDetailJson | null,
    processingGetInquiry: number,
    processingUpdate: number,
    processingRegister: number,
}>;

const inquiryInitialState: InquiryState = {
    inquiries: null,
    processing: 0,
    inquiryDetail: null,
    processingGetInquiry: 0,
    processingUpdate: 0,
    processingRegister: 0
};

const slice = createSlice({
    name: ActionType.base,
    initialState: inquiryInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getInquiryListAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                getInquiryListAction.fulfilled,
                (state, action) => {
                    state.inquiries = action.payload.inquiries;
                    state.processing -= 1;
                }
            )
            .addCase(
                getInquiryListAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                getInquiryDetailAction.pending,
                (state) => {
                    state.processingGetInquiry += 1;
                }
            )
            .addCase(
                getInquiryDetailAction.fulfilled,
                (state, action) => {
                    state.processingGetInquiry -= 1;
                    state.inquiryDetail = action.payload.inquiryDetail;
                }
            ).addCase(
                getInquiryDetailAction.rejected,
                (state) => {
                    state.processingGetInquiry -= 1;
                }
            ).addCase(
                updateInquiryAction.pending,
                (state) => { 
                    state.processingUpdate += 1;
                }
            ).addCase(
                updateInquiryAction.fulfilled,
                (state ,action) => {
                    const { payload } = action;
                    const { inquiry: updatedInquiry } = payload;
                    if (state.inquiryDetail) {
                        state.inquiryDetail.status = updatedInquiry.status;
                        state.inquiryDetail.memo = updatedInquiry.memo;
                    }
                    const target = state.inquiries?.find(inquiry => inquiry.id === updatedInquiry.id);
                    if (target) {
                        target.status = updatedInquiry.status;
                    }
                    state.processingUpdate -= 1;
                }
            ).addCase(
                updateInquiryAction.rejected,
                (state) => {
                    state.processingUpdate -= 1;
                }
            ).addCase(
                registerInquiryAction.pending,
                (state) => {
                    state.processingRegister += 1;
                }
            ).addCase(
                registerInquiryAction.fulfilled,
                (state) => {
                    state.processingRegister -= 1;
                }
            ).addCase(
                registerInquiryAction.rejected,
                (state) => {
                    state.processingRegister -= 1;
                }
            );
    }
});

export const inquiryReducer = slice.reducer;